import { useGetBusinessDetailsQuery } from '../queries';

const SUPPORTED_BOOKING_SOFTWARE = ['NEXHEALTH', 'WEAVE'];

export const useSupportedBookingSoftware = ({ locationId, orgId }: { locationId: string; orgId: string }) => {
  const { data: businessDetailsData } = useGetBusinessDetailsQuery({
    request: { locationId, orgId },
    options: {
      enabled: !!locationId && !!orgId,
    },
  });

  const bookingSoftware = businessDetailsData?.businessDetails?.bookingSoftware;

  const hasSupportedBookingSoftware = SUPPORTED_BOOKING_SOFTWARE.some((s) => s === bookingSoftware);

  return {
    hasSupportedBookingSoftware,
  };
};
